import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'react-final-form';
import { SelectField, Spinner } from '@unite-us/app-components';
import { FIELD_NAMES, LABEL_CLASSNAME } from '../../constants';

const LABEL_STYLES = `mb-1 block text-xs text-dark-grey leading-4 
  tracking-wide font-proxima font-bold ${LABEL_CLASSNAME}`;

export function InteractionTypeRow({
  concept,
  conceptLoading,
  procedureOptions,
  procedureLoading,
}) {
  return (
    <div className="grid w-full grid-cols-2 gap-x-6 gap-y-2">
      <div className="min-w-0">
        <div
          className={LABEL_STYLES}
        >
          Interaction
        </div>
        {conceptLoading && (
          <Spinner
            className="inline-flex items-center"
            scale={0.45}
          />
        )}
        {!conceptLoading && (
          <span
            className="text-sm text-text-blue"
            data-testid="structured-interaction-type"
          >
            {concept?.displayName ?? ''}
          </span>
        )}
      </div>
      <div className="min-w-0">
        <Field name={FIELD_NAMES.codeConceptId}>
          {({ input, meta }) => (
            <SelectField
              className="structured-interactions-field-procedure mb-0"
              data-testid="structured-interaction-procedure"
              disabled_prop={procedureLoading}
              id="structured-interaction-procedure"
              invalid={meta.touched && !!meta.error}
              label="Procedure"
              labelClassName={LABEL_CLASSNAME}
              labelKey="label"
              onBlur={input.onBlur}
              onChange={input.onChange}
              options={procedureOptions}
              placeholder="Select procedure"
              required
              searchEnabled
              touched={meta.touched}
              value={input.value}
              valueKey="value"
              error={meta.touched ? meta.error : undefined}
            />
          )}
        </Field>
      </div>
    </div>
  );
}

InteractionTypeRow.propTypes = {
  concept: PropTypes.shape({
    id: PropTypes.string,
    displayName: PropTypes.string,
  }),
  conceptLoading: PropTypes.bool,
  procedureOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  procedureLoading: PropTypes.bool,
};

InteractionTypeRow.defaultProps = {
  concept: null,
  conceptLoading: false,
  procedureLoading: false,
};
